import React from 'react';
import { Cabin, useGlobalContext } from '@honeycomb/data';
import { useSearchContext } from '../../search/SearchContext';
import { SearchDispatchActionType } from '../../search/SearchReducer';
import { CabinSelector } from '../../search/components/CabinSelector';
export function FlightUpsellCabinSelector() {
    const { resourceStrings: { CABIN_CLASS }, } = useGlobalContext();
    const { searchDispatch, searchState } = useSearchContext();
    const [cabin, setCabin] = React.useState(String(Cabin.Economy));
    React.useEffect(() => {
        setCabin(searchState.cabin ? String(searchState.cabin) : String(Cabin.Economy));
    }, [searchState.cabin]);
    const handleCabinChange = React.useCallback((event) => {
        const { value } = event.target;
        if (!value)
            return;
        setCabin(value);
        searchDispatch({
            type: SearchDispatchActionType.SET_CABIN_CLASS,
            cabinValue: Number(value),
        });
    }, [searchDispatch, setCabin]);
    return (React.createElement(CabinSelector, { FieldProps: {
            value: cabin,
            id: 'cabin-select',
            size: { xs: 'm', m: 'l' },
            label: CABIN_CLASS,
            onChange: handleCabinChange,
            variant: 'filled',
        }, withExternaLabel: false }));
}
